// Argus — DirectoryContextMenu: MUI Menu pe right-click pentru entries în File Explorer.
// Bloc file-explorer-multiselect-download 2026-05-06: adăugat „Download all (N items)"
// condiționat de multi-select activ — funcționează pe orice item right-click când selectedCount ≥ 1.

import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import DownloadingIcon from '@mui/icons-material/Downloading';
import type { FsEntry } from '../../lib/fsEntries';

export interface DirectoryContextMenuProps {
  entry: FsEntry | null;
  anchorPosition: { top: number; left: number } | null;
  onClose: () => void;
  onOpen: (entry: FsEntry) => void;
  onProperties: (entry: FsEntry) => void;
  onDownload?: (entry: FsEntry) => void;
  /** Bloc file-explorer-multiselect-download 2026-05-06: count items selectate (≥ 1 → afișează „Download all"). */
  selectedCount?: number;
  /** Bloc file-explorer-multiselect-download 2026-05-06: handler pentru bulk download. */
  onDownloadAll?: () => void;
}

export function DirectoryContextMenu({
  entry, anchorPosition, onClose, onOpen, onProperties, onDownload,
  selectedCount, onDownloadAll,
}: DirectoryContextMenuProps): JSX.Element {
  const open = entry !== null && anchorPosition !== null;
  const showDownloadAll = (selectedCount ?? 0) >= 1 && onDownloadAll !== undefined;
  const downloadAllLabel = selectedCount === 1 ? 'Download all (1 item)' : `Download all (${selectedCount ?? 0} items)`;

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition ?? undefined}
      slotProps={{ paper: { sx: { minWidth: 200 } } }}
    >
      {entry ? (
        <MenuItem onClick={() => { onOpen(entry); onClose(); }}>
          <ListItemIcon><OpenInNewIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{entry.isDir ? 'Open' : 'Preview'}</ListItemText>
        </MenuItem>
      ) : null}
      {entry && !entry.isDir && onDownload ? (
        <MenuItem onClick={() => { onDownload(entry); onClose(); }}>
          <ListItemIcon><DownloadIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Download…</ListItemText>
        </MenuItem>
      ) : null}
      {showDownloadAll ? (
        <MenuItem onClick={() => { onDownloadAll!(); onClose(); }}>
          <ListItemIcon><DownloadingIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{downloadAllLabel}</ListItemText>
        </MenuItem>
      ) : null}
      {entry ? <Divider /> : null}
      {entry ? (
        <MenuItem onClick={() => { onProperties(entry); onClose(); }}>
          <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Properties</ListItemText>
        </MenuItem>
      ) : null}
    </Menu>
  );
}
